export function mapLineBreaksToHtmlBreaks<T extends string | null | undefined>(text: T): T {
  return text?.trim().replaceAll("\n", "<br/>") as T
}
